import { HStack, IconButton, useMediaQuery } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import { useIntl } from 'react-intl';

import ContextMenu from '../utils/ContextMenu';
import Tooltip from '../utils/Tooltip';

import { ReactComponent as Copy } from '../../icons/copy.svg';
import { ReactComponent as Expand } from '../../icons/expand.svg';
import { ReactComponent as AddPortfolio } from '../../icons/add-portfolio.svg';
import { ReactComponent as AddItem } from '../../icons/add-item.svg';
import { ReactComponent as Move } from '../../icons/move.svg';

const PortfolioLabelIcons = ({ selected, onCopy, onExpandChange, onAddPortfolio, onMovePortfolio, onAddItems }) => {
    const [isDesktop] = useMediaQuery('(min-width: 769px)');
    const intl = useIntl();

    const items = [
        {
            id: 1,
            label: intl.formatMessage({ id: 'common_copy_btn_tooltip_and_label' }),
            action: () => onCopy(selected),
            icon: <Copy />,
        },
        {
            id: 2,
            label: intl.formatMessage({ id: 'portfolios_properties_expand_btn_tooltip_and_label' }),
            action: () => onExpandChange(selected),
            icon: <Expand />,
        },
        {
            id: 3,
            label: intl.formatMessage({ id: 'portfolios_properties_add_portfolio_btn_tooltip_and_label' }),
            action: () => onAddPortfolio(selected),
            icon: <AddPortfolio />,
        },
        {
            id: 4,
            label: intl.formatMessage({ id: 'portfolios_properties_add_item_btn_tooltip_and_label' }),
            action: () => onAddItems(selected),
            icon: <AddItem />,
        },
        {
            id: 5,
            label: intl.formatMessage({ id: 'portfolios_properties_move_btn_tooltip_and_label' }),
            action: () => onMovePortfolio(selected),
            icon: <Move />,
        },
    ];

    return isDesktop ? (
        <Wrapper className="icons-wrapper">
            {items.map((item) => (
                <Tooltip key={item.id} label={item.label}>
                    <CustomIcon icon={item.icon} aria-label={item.label} onClick={item.action} />
                </Tooltip>
            ))}
        </Wrapper>
    ) : (
        <ContextMenu aria-label={intl.formatMessage({ id: 'common_actions' })} items={items} />
    );
};

const Wrapper = styled(HStack)`
    display: none;
    margin-left: auto;
`;

const CustomIcon = styled(IconButton)`
    height: 24px;
    width: 24px;
    background: none;
    min-height: 0;
    min-width: 0;
    color: var(--chakra-colors-gray-600);

    &:focus,
    &:hover {
        background: none;
        box-shadow: none;

        svg path {
            fill: var(--chakra-colors-blue-400);
        }
    }
`;

export default PortfolioLabelIcons;
